import {noop} from '@github-ui/noop'
import {createContext} from 'react'

export const ViewMode = {
  ReviewComments: 'review-comments',
  ThreadPreviews: 'thread-previews',
  IssueComments: 'issue-comments',
} as const

export type ViewMode = (typeof ViewMode)[keyof typeof ViewMode]

export interface CommentsContext {
  viewMode: ViewMode
  setViewMode: (viewMode: ViewMode) => void
  /** Tab size to use for rendering code snippet previews. */
  tabSize?: number
  /** Unique anchor prefix to prepend to comment IDs. */
  commentAnchorPrefix?: string
}

export const CommentsContext = createContext<CommentsContext>({
  viewMode: ViewMode.ThreadPreviews,
  setViewMode: noop,
  tabSize: 4,
})
